import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = request.url.toLowerCase();
    
    const validateUrl = url.includes(environment.apiEndpoint);
    
    if (validateUrl) {
      const credentials: any = JSON.parse(sessionStorage.getItem(`credentials_${environment.appId}`)!);
      if(credentials) {
        const clonedRequest = request.clone({setHeaders: {'X-Bitc-Username': credentials.userName, 'X-Bitc-Sessionid': credentials.sessionId, 'X-Bitc-Database': credentials.database, 'Access-Control-Allow-Origin': '*'}})
        return next.handle(clonedRequest);
      } /* else {
        const clonedRequest = request.clone({setHeaders: {'Access-Control-Allow-Origin': '*'}});
        return next.handle(clonedRequest);
      } */
    }
    return next.handle(request);
  }
}
